import { publicationApi } from '../../api/publications';
import { createCategorySlice } from './categorySlice';
import { createContentSlice } from './contentSlice';

const { slice, actions } = createContentSlice({
  name: 'publications',
  api: publicationApi,
  hasPublish: true,
});

const categoryFactory = createCategorySlice({
  name: 'publicationCategories',
  api: publicationApi.categories,
});

export const publicationReducer = slice.reducer;
export const publicationActions = actions;

export const publicationCategoryReducer = categoryFactory.slice.reducer;
export const publicationCategoryActions = categoryFactory.actions;

export const selectPublications = (state) => state.publications.items;
export const selectPublicationsStatus = (state) => state.publications.status;
export const selectPublicationCategories = (state) => state.publicationCategories.items;
